import React, { useState, useEffect } from "react";
import axios from "axios";
import { SubmitButton } from "../components/Input";
import { API_URL } from "../config";
import { showToast } from "../components/toast"; // Optional toast if you use it

const ChangePassword: React.FC = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [userId, setUserId] = useState(null);

  // 🔐 Get user ID from role-detail (secure)
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    axios
      .get(`${API_URL}auth/role-detail`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const id = res.data?.data?.id;
        if (id) setUserId(id);
      })
      .catch(() => {
        showToast?.error("Failed to fetch user info");
      });
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const newErrors: any = {};

    // Validate
    if (!oldPassword) newErrors.oldPassword = "Old Password is Required.";
    if (!newPassword) newErrors.newPassword = "New Password is Required.";
    // if (newPassword && !isValidPassword(newPassword)) {
    //   newErrors.newPassword =
    //     "Password is not strong. It must contain at least 10 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.";
    // }
    if (!confirmPassword)
      newErrors.confirmPassword = "Confirm Password is Required.";
    if (confirmPassword !== newPassword)
      newErrors.confirmPassword =
        "New Password and Confirm Password do not match.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // API call
    try {
      const token = localStorage.getItem("authToken");
      if (!token || !userId) return;

      const payload = {
        current_password: oldPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      };

      const res = await axios.put(
        `${API_URL}user/change-password/${userId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data?.success) {
        showToast?.success("Password changed successfully!");
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setErrors({});
      } else {
        showToast?.error(res.data?.message || "Failed to change password.");
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        "Something went wrong while changing the password.";
      showToast?.error(msg);
    }
  };

  const isValidPassword = (password: string) => {
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;
    const numberRegex = /[0-9]/;
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return (
      password.length >= 10 &&
      uppercaseRegex.test(password) &&
      lowercaseRegex.test(password) &&
      numberRegex.test(password) &&
      specialCharRegex.test(password)
    );
  };

  const generateStrongPassword = (length: number) => {
    const chars =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    let password = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      password += chars[randomIndex];
    }
    return password;
  };

  const handleGeneratePassword = () => {
    const password = generateStrongPassword(10);
    setNewPassword(password);
  };

  return (
    <div className="panel panel-default with-rounded-corner with-shadow mt-5">
      <div>
        <form onSubmit={handleSubmit} className="stdform">
          <div className="panel-heading border-0">
            <span className="panel-title">Change Password</span>
          </div>
          <div className="panel-body">
            <div className="row mb-4">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label semibold">Old Password</label>
                  <input
                    type="password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    placeholder="Enter Old Password"
                    className={`form-control ${
                      errors.oldPassword ? "is-invalid" : ""
                    }`}
                  />
                  {errors.oldPassword && (
                    <small className="text-danger">{errors.oldPassword}</small>
                  )}
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label semibold">
                    New Password{" "}
                    <small>
                      <a
                        className="gen_pass"
                        href="#"
                        onClick={handleGeneratePassword}
                        style={{ color: "blue" }}
                      >
                        Generate Password
                      </a>
                    </small>
                  </label>
                  <input
                    type="text"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter New Password"
                    className={`form-control ${
                      errors.newPassword ? "is-invalid" : ""
                    }`}
                  />
                  {errors.newPassword && (
                    <small className="text-danger">{errors.newPassword}</small>
                  )}
                </div>
              </div>
            </div>
            <div className="row ">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label semibold">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Enter Confirm Pass"
                    className={`form-control ${
                      errors.confirmPassword ? "is-invalid" : ""
                    }`}
                  />
                  {errors.confirmPassword && (
                    <small className="text-danger">
                      {errors.confirmPassword}
                    </small>
                  )}
                </div>
              </div>
            </div>
            <div className="clearfix"></div>
            <SubmitButton pageBack="/profile" handleSubmit={handleSubmit} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
